import React from 'react';
import {FormattedMessage} from 'react-intl';
import ButtonAction from '../../../../common/components/ui/ButtonAction';
import styles from './ButtonLogin.module.scss'
import {useLoginContext} from "../LoginContext";

const ButtonLogin = () => {
  const {onClick} = useLoginContext();

  return (
    <div className={styles.buttonLoginContainer}>
      <ButtonAction
        variant={'button'}
        type={'button'}
        label={(
          <FormattedMessage
            id={'login-button-login'}
            defaultMessage={'Login'}
          />
        )}
        customClassnames={{container: styles.button}}
        onClick={onClick}
      />
    </div>
  );
};

export default ButtonLogin;
